module.exports = __webpack_public_path__ + "static/media/Mysti-cards2 1.740f6ff2.png";